import { Injectable } from '@angular/core';
import { Observable, from } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class TypeStateService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('TypeState');
	}

	loadAll(country: string): Observable<ePM.Logic.TypeState[]> {
		if (country) {
			return this.myBaseService.loadAll(this.url + '/' + (country || ''));
		}
		return from([]);
	}
}
